import { Requirements } from 'app/routes';

import {
    CampaignModerationInfo,
    ModerationReason,
    setCampaignModerationList,
    setModerationReasons,
} from 'store/models/moderation';

export const ModerationListPageRequirements: Requirements<{
    campaignModerationList: CampaignModerationInfo[];
    moderationReasons: ModerationReason[];
}> = {
    methods: () => ({
        campaignModerationList: { url: '/api/v1/moderation/list', cacheable: false },
        moderationReasons: { url: '/api/v1/catalog/moderation/reasons', cacheable: true },
    }),
    resolve: ({ result: { campaignModerationList, moderationReasons } }) => [
        setCampaignModerationList(campaignModerationList),
        setModerationReasons(moderationReasons),
    ],
};
